import { ActivityEntryCard } from '../ActivityEntryCard/ActivityEntryCard';
import { FoodEntryCard } from '../FoodEntryCard/FoodEntryCard';
import { StoolEntryCard } from '../StoolEntryCard/StoolEntryCard';
import { SymptomEntryCard } from '../SymptomEntryCard/SymptomEntryCard';
import {
  isActivityEntry,
  isFoodEntry,
  isStoolEntry,
  isSymptomEntry,
  isWaterEntry,
  isWeightEntry,
  JournalEntry,
} from '../types';
import { WaterIntakeEntryCard } from '../WaterIntakeEntryCard/WaterIntakeEntryCard';
import { WeightEntryCard } from '../WeightEntryCard/WeightEntryCard';

export interface JournalEntryDispatcherProps {
  entry: JournalEntry;
}

/**
 * Dispatches to the appropriate entry card component based on __typename.
 * This is the main entry point for rendering any journal entry.
 */
export const JournalEntryDispatcher: React.FC<JournalEntryDispatcherProps> = ({
  entry,
}) => {
  if (isFoodEntry(entry)) {
    return <FoodEntryCard entry={entry} />;
  }

  if (isWaterEntry(entry)) {
    return <WaterIntakeEntryCard entry={entry} />;
  }

  if (isSymptomEntry(entry)) {
    return <SymptomEntryCard entry={entry} />;
  }

  if (isStoolEntry(entry)) {
    return <StoolEntryCard entry={entry} />;
  }

  if (isWeightEntry(entry)) {
    return <WeightEntryCard entry={entry} />;
  }

  if (isActivityEntry(entry)) {
    return <ActivityEntryCard entry={entry} />;
  }

  // Fallback for unknown entry types
  return null;
};

JournalEntryDispatcher.displayName = 'JournalEntryDispatcher';
